export enum Bidder {
  appnexus = 'appnexus',
  brealtime = 'brealtime',
  ixVideo = 'ixVideo',
  oneVideo = 'oneVideo',
  openx = 'openx',
  pubmatic = 'pubmatic',
  rubicon = 'rubicon'
}

export default Bidder
